import { createContext } from 'react';

const NewPlanContext = createContext();

export default NewPlanContext;